import { INDICATOR } from "../config/indicators"

const FIELDNAME_MAP = {
  symptom: {
    "question": "Har du, eller har du haft återkommande problem med att få och/eller behålla tillräcklig erektion?",
    "definition": "Patienten har återkommande problem med att få och/eller behålla erektion",
    "indicator": INDICATOR.NO_SYMPTOM,
    "kaddioId": 1
  },
  livsstil_option_1: {
    "definition": "Patienten röker",
    "indicator": INDICATOR.O_VASK
  },
  livsstil_option_2: {
    "definition": "Patienten är överviktig",
    "indicator": INDICATOR.O_VASK
  },
  livsstil_option_3: {
    "definition": "Patienten dricker mycket alkohol",
    "indicator": INDICATOR.KO_ALK
  },
  sjukdomar_1_option_1: {
    "definition": "Patienten har haft hjärtinfarkt",
    "indicator": INDICATOR.KO_HJART
  },
  sjukdomar_1_option_2: {
    "definition": "Patienten har haft stroke",
    "indicator": INDICATOR.KO_STROKE
  },
  sjukdomar_2_option_1: {
    "definition": "Patienten har haft diabetes mellitus",
    "indicator": INDICATOR.O_VASK
  },
  sjukdomar_2_option_2: {
    "definition": "Patienten har haft kärlkramp i bröstet",
    "indicator": INDICATOR.KO_HJART
  },
  sjukdomar_2_option_3: {
    "definition": "Patienten har haft multipel skleros eller annan nervsjukdom",
    "indicator": INDICATOR.O_NERV
  },
  sjukdomar_3_option_1: {
    "definition": "Patienten har haft kraftigt nedsatt lever- eller njurfunktion",
    "indicator": INDICATOR.KO_LEV_NJUR
  },
  sjukdomar_3_option_2: {
    "definition": "Patienten har haft lågt blodtryck (under 90/50 mm hg)",
    "indicator": INDICATOR.KO_BLODTRYCK
  },
  sjukdomar_3_option_3: {
    "definition": "Patienten har haft sjukdom som påverkar penisformen",
    "indicator": INDICATOR.KO_ANATOMI
  },
  trauma_option_1: {
    "definition": "Patienten har skadat penis eller bäckenet",
    "indicator": INDICATOR.KO_TVASK
  },
  trauma_option_2: {
    "definition": "Patienten har opererat prostatan",
    "indicator": INDICATOR.O_NERV
  },
  anatomi_option_1: {
    "definition": "Patienten har haft brösttillväxt",
    "indicator": INDICATOR.O_HORM
  },
  anatomi_option_2: {
    "definition": "Patienten har haft minskad hårväxt eller minskat rakningsbehov",
    "indicator": INDICATOR.O_HORM
  },
  anatomi_option_3: {
    "definition": "Patienten har haft små eller krympande testiklar",
    "indicator": INDICATOR.O_HORM
  },
  psykologi_option_1: {
    "definition": "Patienten har regelbundna erektioner på morgonen",
    "indicator": INDICATOR.O_PSYK
  },
  psykologi_option_2: {
    "definition": "Patienten har upplevt nedstämdhet",
    "indicator": INDICATOR.O_PSYK
  },
  psykologi_option_3: {
    "definition": "Patienten har upplevt stress",
    "indicator": INDICATOR.O_PSYK
  },
  psykologi_option_4: {
    "definition": "Patienten upplever problem i parförhållande som påverkar sexlusten",
    "indicator": INDICATOR.O_PSYK
  },
  lakemedel: {
    "question": "Tar du några läkemedel?",
    "definition": "Patienten tar läkemedel",
    "indicator": INDICATOR.LAKEMEDEL,
    "kaddioId": 22
  },
  lakemedel_hjartrelaterade_option_1: {
    "definition": "Patienten tar blodkärlsvidgande läkemedel",
    "indicator": INDICATOR.KO_LAKEMEDEL
  },
  lakemedel_blodtrycksrelaterade_option_1: {
    "definition": "Patienten tar vätskedrivande läkemedel",
    "indicator": INDICATOR.KO_LAKEMEDEL
  },
  lakemedel_blodtrycksrelaterade_option_2: {
    "definition": "Patienten tar betablockerare",
    "indicator": INDICATOR.KO_LAKEMEDEL_ADEMPAS
  },
  lakemedel_etc_option_1: {
    "definition": "Patienten tar läkemedel mot HIV",
    "indicator": INDICATOR.KO_LAKEMEDEL_HIV
  },
  lakemedel_etc_option_2: {
    "definition": "Patienten tar cellgifter mot cancer",
    "indicator": INDICATOR.KO_LAKEMEDEL_CANCER
  },
  email: {
    "question": "E-postadress?",
    "definition": "",
    "indicator": ""
  }
}

export function getFieldDefinition(name) {
  return FIELDNAME_MAP[name]
}
